import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=c237b582&scoped=true&"
import script from "./AdditionalInfo.vue?vue&type=script&lang=ts&"
export * from "./AdditionalInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalInfo.vue?vue&type=style&index=0&id=c237b582&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c237b582",
  null
  
)

export default component.exports